import { Typography } from '@mui/material';
import React from 'react';
import './Profile.css'
import profilePic from '../../assets/images/displayImages.jpg'
import CustomTimeline, { CustomTimelineSeparator } from '../Timeline/CustomTimeline';
import useData from '../../Hooks/useData';
import { GetApp, PersonOutlineRounded } from '@mui/icons-material';
import { TimelineContent, TimelineItem } from '@mui/lab';
import CustomButton from '../Button/Button';

const CustomTimelineItem = ({ title, text, link }) => {
    return (
        <TimelineItem>
            <CustomTimelineSeparator />
            <TimelineContent className='timeline-content'>
                {link ? (
                    <Typography className="timelineItem-text"><span>{title}:</span>{" "} <a href={link} target="_blank" rel="noopener noreferrer">{text}</a> </Typography>
                ) : (
                    <Typography className="timelineItem-text"><span>{title}:</span>{" "} {text}</Typography>
                )}
            </TimelineContent>
        </TimelineItem>
    )
}


const Profile = () => {
    const { name, title, email, phone1, dob,address } = useData();

    return (
        <div className="profile container-shadow">
            <div className="profile-name">
                <Typography className="name">{name}</Typography>
                <Typography className="title">{title}</Typography>
            </div>
            <figure className="profile-image">
                <img src={profilePic} alt="" />
            </figure>
            <div className="profile-information">
                <CustomTimeline
                    icon={<PersonOutlineRounded />}>
                    <CustomTimelineItem title={"Name"} text={name} />
                    <CustomTimelineItem title={"Birthday"} text={dob} />
                    <CustomTimelineItem title={"Phone"} text={phone1} />
                    <CustomTimelineItem title={"Email"} text={email} />
                    <CustomTimelineItem title={"Address"} text={address} />
                </CustomTimeline>

                <br />
                <div className="button-container">

                <a style={{textDecoration:"none"}} href="https://drive.google.com/file/d/1-iD5aDhXCk0YaSnk7jrM945t4ktpLxWF/view?usp=sharing" target="_blank" rel="noopener noreferrer"><CustomButton text={"Download CV"} icon={<GetApp />}></CustomButton></a>
                
                </div>
            </div>

        </div>
    );
};

export default Profile;